import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please fill out this field.' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please fill out this field.' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please fill out this field.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    siteName: {
      validations: [
        { type: 'required', message: 'Please fill out this field.' },
      ]
    },
    theme: {
      validations: [
        { type: 'required', message: 'Please fill out this field.' },
      ]
    },
    category: {
      validations: []
    },
    description: {
      validations: []
    },
    Reference: {
      validations: []
    },
    SalesRep: {
      validations: []
    },
    notes: {
      validations: []
    },
    accountextra1: {
      validations: []
    },
    accountextra2: {
      validations: []
    },
    accountextra3: {
      validations: []
    },
    accountextra4: {
      validations: []
    },
    accountextra5: {
      validations: []
    },
    accountextra6: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'FIRST NAME *',
            mapping: 'firstName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'LAST NAME *',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'EMAIL ADDRESS *',
            mapping: 'email'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'TELEPHONE (OPTIONAL)',
            mapping: 'telNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'LOCATION *',
            options: [
              { label: 'Northern Utah', value: 'Northern Utah' },
              { label: 'Southern Utah (St. George)', value: 'Southern Utah (St. George)' }
            ],
            mapping: 'category'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'CONVERSATION TOPIC *',
            options: [
              { label: 'Wedding Catering', value: 'Wedding Catering' },
              { label: 'Corporate or Party Catering', value: 'Corporate or Party Catering' },
              { label: 'General Contact', value: 'General Contact' }
            ],
            mapping: 'description'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Reference',
            mapping: 'Reference'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'Acct. Coord.',
            mapping: 'SalesRep'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'MESSAGE',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'page',
            mapping: 'accountextra1'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'utm_source',
            mapping: 'accountextra2'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'utm_medium',
            mapping: 'accountextra3'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'utm_campaign',
            mapping: 'accountextra4'
      },{
            type: 'text',
            size: 'Medium',
            label: 'utm_term',
            mapping: 'accountextra5'
      },{
            type: 'text',
            size: 'Medium',
            label: 'utm_content',
            mapping: 'accountextra6'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SEND'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Magleby\'s Restaurant & Catering Contact Us Form',
    formId: '550',
    clientKey: '21E3DABF-D8FC-49AE-9168-CA9C0179646B',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/client_forms/maglebys1/form_structure.js